<template>
  <v-card-title class="headline white--text text-left" v-bind:class="this.colorProp">
    {{ name }}
    <v-spacer></v-spacer>
    <v-icon large color="white">{{ icon }}</v-icon>
  </v-card-title>
</template>

<script>
export default {
  name: "CardTitle",
  components: {},
  props: {
    name: {
      type: String,
      default: "NotDefined",
      required: false,
    },
    colorProp: {
      type: String,
      default: "cyan",
      required: false,
    },
    icon: {
      type: String,
      default: "mdi-home",
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    dynamicStyle() {
      return {
        color: `rgb(${this.redComp}, ${this.greenComp}, ${this.blueComp});`,
      };
    },
  },
};
</script>

<style scoped></style>
